import { render, staticRenderFns } from "./ImporterModal.vue?vue&type=template&id=032bcd2c"
import script from "./ImporterModal.vue?vue&type=script&lang=ts"
export * from "./ImporterModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports